import Solutions from "../../components/PSTVue/Solutions";
import Landing from "../../components/PSTVue/Landing";
import Navbar from "../../components/PSTVue/Navbar2";
import React from "react";
import EducationRoles from "../../components/PSTVue/EducationRoles";
import Features from "../../components/PSTVue/Features";
import WhyChooseCard from "../../components/PSTVue/WhyChooseCard";
import Testimonials from "../../components/PSTVue/Testimonials";
// import Footer from "../../components/PSTVue/Footer";


const PSTVue = () => {
  return (
    <div>
      <Navbar />
      <Landing />
      <Solutions/>
      <EducationRoles/>
      <Features/>
      <WhyChooseCard/>
      <Testimonials/>
      {/* <Footer/> */}
    </div>
  );
};

export default PSTVue;